<template>
	<v-dialog
		v-model="dialog"
		max-width="500"
	>
		<template #activator="{ props }">
			<v-btn
				variant="plain"
				class="text-none pl-1 pr-1"
				v-bind="props"
			>
				<v-icon
					color="primary"
					icon="$info"
				/>
				<translate>How do I find the IMEI number on my device?</translate>
			</v-btn>
		</template>

		<v-card>
			<v-card-title>
				<translate>
					IMEI
				</translate>
			</v-card-title>
			<v-card-text>
				<v-list>
					<v-list-subheader>
						<translate>How do I find the IMEI number on my device?</translate>
					</v-list-subheader>
					<v-list-item
						v-for="(item, i) in onDeviceList"
						:key="i"
					>
						{{ i+1 }}. {{ item.text }}
					</v-list-item>
				</v-list>
				<v-list>
					<v-list-subheader>
						<translate>How do I find the IMEI number if I don't have my device at hand?</translate>
					</v-list-subheader>
					<v-list-item
						v-for="(item, i) in withoutDeviceList"
						:key="i"
					>
						{{ item.text }}
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					@click="dialog=false"
				>
					<translate>Okay</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	name: 'ImeiInfoDialog',

	data () {
		return {
			dialog: false
		};
	},

	computed: {
		onDeviceList () {
			return [
				{
					text: this.$gettext('Open the Phone app on your mobile phone and dial the key combination ' +
						'*#06#. The number combination that appears on your screen is the IMEI number. If more than ' +
						'one IMEI is displayed, use the IMEI1 number.')
				},
				{
					text: this.$gettext('Alternatively, you can search for the IMEI number in the Settings app ' +
						'on your device. To do this, open Settings and look for a menu that is often called "About ' +
						'the phone". In that menu, look for "Info" or "Status". There you will usually also find the ' +
						'IMEI. Sometimes you can also use the search option in the Settings app, by typing the word ' +
						'\'IMEI\' in the search box.')
				},
			];
		},

		withoutDeviceList () {
			return [
				{
					text: this.$gettext('If you do not have your device at hand, you can also find the IMEI ' +
						'on the original packaging, or on your receipt of the purchase.')
				},
			];
		}
	}

};
</script>

